export type CodePurpose = "register" | "login" | "resetPassword";
type CodeState = { retryAt: number; purpose?: CodePurpose; expiresAt?: number };
const memory = new Map<string, CodeState>();

// UI hints only, never proof of verification. No phone, OTP, password or token is stored.
export async function codeStateKey(phone: string) {
  try {
    const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(phone));
    return `truth-company-sms:${Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("")}`;
  } catch {
    // Non-secure browser contexts may lack SubtleCrypto. Keep hints in memory only.
    return `memory:${phone}`;
  }
}

export function readCodeState(key: string): CodeState {
  if (!key) return { retryAt: 0 };
  let value = memory.get(key);
  try { if (!key.startsWith("memory:")) value = JSON.parse(sessionStorage.getItem(key) || "null") || value; } catch { /* storage may be blocked */ }
  const now = Date.now();
  const retryAt = typeof value?.retryAt === "number" && value.retryAt > now && value.retryAt <= now + 86400_000 ? value.retryAt : 0;
  const purpose = value?.purpose;
  const validPurpose = purpose === "register" || purpose === "login" || purpose === "resetPassword";
  if (validPurpose && typeof value?.expiresAt === "number" && value.expiresAt > now && value.expiresAt <= now + 15 * 60_000) {
    return { retryAt, purpose, expiresAt: value.expiresAt };
  }
  return { retryAt };
}

export function writeCodeState(key: string, value: CodeState) {
  if (!key) return;
  memory.set(key, value);
  try { if (!key.startsWith("memory:")) sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* in-memory fallback */ }
}
